import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { AppRoutes } from "./path";
import Profile from "../pages/Profile";

const Loadable = (Component: React.ElementType) => (props: any) => {
  return (
    <Suspense
      fallback={
        <div>
          <div className="text-center">
            <p className="text-sm text-gray-400">Loading...</p>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-400">Please wait a moment.</p>
          </div>
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    { path: AppRoutes.home, element: <Home /> },
    { path: AppRoutes.products, element: <ProductsList /> },
    { path: AppRoutes.productDetail + "/:id", element: <ProductDetail /> },
    { path: AppRoutes.checkout, element: <Checkout /> },
    { path: AppRoutes.cart, element: <Cart /> },
    { path: AppRoutes.login, element: <Login /> },
    { path: AppRoutes.register, element: <SignUp /> },
    { path: AppRoutes.forgotPassword, element: <ForgotPassword /> },
    { path: AppRoutes.resetPassword, element: <ResetPassword /> },
    { path: AppRoutes.changePassword, element: <ChangePassword /> },
    { path: AppRoutes.reviewList, element: <ReviewLists /> },
    { path: AppRoutes.editReview, element: <EditReview /> },
    { path: AppRoutes.profile, element: <Profile /> },
    { path: AppRoutes.orderSuccess, element: <OrderSuccess /> },
    { path: AppRoutes.order, element: <Order /> },
    { path: AppRoutes.orderDetail, element: <OrderDetail /> },
    { path: AppRoutes.favorite, element: <Favorite /> },
    // { path: AppRoutes.promotion, element: <Promotion /> },
    { path: AppRoutes.promotion + "/:id", element: <Promotion /> },
    { path: AppRoutes.aboutUs, element: <AboutUs /> },
    { path: AppRoutes.contactUs, element: <ContactUs /> },
    { path: AppRoutes.errorPage, element: <ErrorPage /> },
    { path: AppRoutes.privacy, element: <PrivacyPolicy /> },

    { path: "*", element: <ErrorPage/> },
  ]);
}

const Home = Loadable(lazy(() => import("../pages/Home")));
const ProductsList = Loadable(lazy(() => import("../pages/ProductsList")));
const ProductDetail = Loadable(lazy(() => import("../pages/ProductDetails")));
const Checkout = Loadable(lazy(() => import("../pages/Checkout")));
const Cart = Loadable(lazy(() => import("../pages/Cart")));
const Login = Loadable(lazy(() => import("../pages/Login")));
const SignUp = Loadable(lazy(() => import("../pages/SignUp")));
const ForgotPassword = Loadable(lazy(() => import("../pages/ForgotPassword")));
const ResetPassword = Loadable(lazy(() => import("../pages/ResetPassword")));
const ChangePassword = Loadable(lazy(() => import("../pages/ChangePassword")));
const ReviewLists = Loadable(lazy(() => import("../pages/ReviewLists")));
const EditReview = Loadable(lazy(() => import("../pages/EditReview")));
const OrderSuccess = Loadable(lazy(() => import("../pages/OrderSuccess")));
const Order = Loadable(lazy(() => import("../pages/Order")));
const OrderDetail = Loadable(lazy(() => import("../pages/OrderDetails")));
const Favorite = Loadable(lazy(() => import("../pages/Favorite")));
const Promotion = Loadable(lazy(() => import("../pages/Promotion")));
const AboutUs = Loadable(lazy(() => import("../pages/AboutUs")));
const ContactUs = Loadable(lazy(() => import("../pages/ContactUs")));
const ErrorPage = Loadable(lazy(() => import("../pages/ErrorPage")));
const PrivacyPolicy = Loadable(lazy(() => import("../pages/PrivacyPolicy")));